enum DiscardedLeadReasonEnum {
    AgentAssignerFailed = 'AGENT_ASSIGNER_FAILED',
    AnnotationStrategyFailed = 'ANNOTATION_STRATEGY_FAILED',
    EnrichmentFailed = 'ENRICHMENT_FAILED'
}

export default DiscardedLeadReasonEnum
